import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import css from './index.module.scss';
gsap.registerPlugin(ScrollTrigger);

const cardConfig = {
    containerWidth: '1128px',
    cardItemWidth: '360px',
    itemsConfig: [
        {
            key: 0,
            height: '636px',
            color: '#03060b',
            subTitleColor: '#020814',
            mainTitleColor: '#000',
            textColor: '#03060b',
            bgColor: '#d9d6cc',
        },
        {
            key: 1,
            height: '730px',
            color: '#03060b',
            subTitleColor: '#020814',
            mainTitleColor: '#000',
            textColor: '#03060b',
            bgColor: '#ffd26c',
        },
        {
            key: 2,
            height: '564px',
            color: '#FFF',
            bgColor: '#1e1e1f',
        },
        {
            key: 3,
            height: '694px',
            color: '#FFF',
            bgColor: '#027aff',
        },
        {
            key: 4,
            height: '600px',
            color: '#03060b',
            bgColor: '#d9d6cc',
        },
        {
            key: 5,
            height: '766px',
            color: '#000000',
            bgColor: '#59b35f',
        },
    ],
};
export default function Section10() {
    const { useEffect, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_new');
    const cardData = [
        {
            key: 0,
            icon: '/media/deltapro/pc/icon/07-icon-01.svg',
            sutTitle: t('EV_SC'),
            mainTitle: t('EV_SC_sub_title'),
            text: t('EV_SC_desc'),
        },
        {
            key: 1,
            icon: '/media/deltapro/pc/icon/07-icon-02.svg',
            sutTitle: t('SP_Charging'),
            mainTitle: t('SP_Charging_sub_title'),
            text: t('SP_Charging_desc'),
        },
        {
            key: 2,
            icon: '/media/deltapro/pc/icon/07-icon-03.svg',
            mainTitle: t('wall_charge_sub_title'),
            text: t('wall_charge_desc'),
        },
        {
            key: 3,
            icon: '/media/deltapro/pc/icon/07-icon-04.svg',
            sutTitle: t('smart_home_panel'),
            mainTitle: t('smart_home_panel_sub_title'),
            text: t('smart_home_panel_desc'),
        },
        {
            key: 4,
            icon: '/media/deltapro/pc/icon/07-icon-05.svg',
            sutTitle: t('car_charging'),
            mainTitle: t('car_charging_sub_title'),
            text: t('car_charging_desc'),
        },
        {
            key: 5,
            icon: '/media/deltapro/pc/icon/07-icon-06.svg',
            sutTitle: t('SG_charging'),
            mainTitle: t('SG_charging_sub_title'),
            text: t('SG_charging_desc'),
        },
    ];
    useEffect(() => {
        /* -start- 卡片动画 */
        const TL = gsap.timeline({
            scrollTrigger: {
                trigger: '.cardList',
                start: 'top bottom',
                end: 'bottom bottom',
                scrub: 0.2,
                fastScrollEnd: true,
            },
        });
        TL.from('.catdItem.item1', {
            top: 150,
            duration: 1,
        });
        TL.from(
            '.catdItem.item2',
            {
                top: 300,
                duration: 1,
            },
            0,
        );
        TL.from(
            '.catdItem.item3',
            {
                top: 150,
                duration: 1,
            },
            1,
        );
        TL.from(
            '.catdItem.item4',
            {
                top: 100,
                duration: 1,
            },
            1,
        );
        TL.from(
            '.catdItem.item5',
            {
                top: -66,
                duration: 1,
            },
            1,
        );

        if (locale === 'cn') {
            // cn盒子高度减小100
            cardConfig.itemsConfig &&
                cardConfig.itemsConfig.map((item, index) => {
                    const cnHeight = parseInt(item.height) - 100;
                    if (index >= 3) cnHeight - 30;
                    item.height = `${cnHeight}px`;
                });
        }
        /* -end- 卡片动画 */
        return () => {
            TL.kill();
        };
    }, []);

    return (
        <ul className={`cardList ${css.section10} GtmModuleData-section`} data-section-id={css.section10} data-section-title={t('feature_desc')}>
            {cardData.map((item, index) => {
                const itemStyle = cardConfig.itemsConfig.find((itemSty) => itemSty.key === item.key);
                return (
                    <li
                        key={item.key}
                        className={`catdItem item${index}`}
                        style={{
                            height: itemStyle?.height,
                            backgroundColor: itemStyle?.bgColor,
                            color: itemStyle?.color,
                        }}
                    >
                        <Image src={item.icon} width={72} height={72} />
                        <div>
                            {item.sutTitle && (
                                <h4
                                    className="subTitle font-family-bold"
                                    style={{
                                        color: itemStyle?.subTitleColor || 'inherit',
                                    }}
                                >
                                    {item.sutTitle}
                                </h4>
                            )}
                            {item.mainTitle && (
                                <h2
                                    className="mainTitle font-family-extrabold"
                                    style={{
                                        color: itemStyle?.mainTitleColor || 'inherit',
                                    }}
                                >
                                    {item.mainTitle}
                                </h2>
                            )}
                            {item.text && (
                                <p
                                    className="text font-family-semibold"
                                    style={{
                                        color: itemStyle?.textColor || 'inherit',
                                    }}
                                >
                                    {item.text}
                                </p>
                            )}
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}
